import React, { useEffect } from 'react';
import './ApprovalAnimation.css';

function ApprovalAnimation({ onComplete }) {
  useEffect(() => {
    const timer = setTimeout(() => {
      if (onComplete) onComplete();
    }, 4000);
    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <div className="approval-animation-overlay">
      <div className="approval-animation-container">
        <div className="approval-checkmark-circle">
          <svg className="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
            <circle className="checkmark-circle" cx="26" cy="26" r="25" fill="none"/>
            <path className="checkmark-check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
          </svg>
        </div>
        <h1 className="approval-title">Approved!</h1>
        <p className="approval-message">Your submission has been successfully approved and is being registered on the blockchain.</p>
        <div className="approval-loader">
          <div className="loader-bar"></div>
        </div>
        <p className="approval-status">Processing blockchain registration...</p>
      </div>
    </div>
  );
}

export default ApprovalAnimation;
